import { useState } from 'react';
import { api, extractError } from '../../lib/api';
import { t } from '../../i18n/pt';
import { Button } from '../ui/Button';

type Status = 'idle' | 'sending' | 'sent' | 'error';

interface Props {
  variant?: 'primary' | 'secondary' | 'link' | 'ghost';
  size?: 'md' | 'lg';
  className?: string;
  messageClassName?: string;
}

/**
 * Re-triggers the account email-verification link. Used by the account banner
 * and the checkout gate for logged-in-but-unverified users.
 */
export function ResendVerificationButton({
  variant = 'secondary',
  size = 'md',
  className,
  messageClassName,
}: Props): JSX.Element {
  const [status, setStatus] = useState<Status>('idle');
  const [message, setMessage] = useState<string | null>(null);

  const resend = async (): Promise<void> => {
    setStatus('sending');
    setMessage(null);
    try {
      await api.post('/auth/resend-verification');
      setStatus('sent');
      setMessage(t.auth.verifyResent);
    } catch (err) {
      setStatus('error');
      setMessage(extractError(err, t.auth.verifyResendError));
    }
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => {
          void resend();
        }}
        disabled={status === 'sending' || status === 'sent'}
      >
        {status === 'sending' ? t.auth.verifyResending : t.auth.verifyResend}
      </Button>
      {message ? <span className={messageClassName}>{message}</span> : null}
    </>
  );
}
